import { render, staticRenderFns } from "./MegaMenu.vue?vue&type=template&id=5b98bf90&"
import script from "./MegaMenu.vue?vue&type=script&lang=js&"
export * from "./MegaMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MegaMenuItem: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/mega-menu/MegaMenuItem.vue').default})
